import React, { Component } from 'react';
import inDevelopment from '../../under-construction.jpg'

export class InDevelopment extends Component {
   render() {
      return (
         <div className="d-flex justify-content-center align-items-center">
            <img src={inDevelopment} alt="under-construction"></img>
         </div>
      )
   }
}

export default InDevelopment
